//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import * as styles from './ko.module.scss';
//------------------------------------------------------------------------------
//------------------------------------------------------------------------------
// Helpers ----------------------------------------------------------------------
import { withTranslation } from 'react-i18next';
//------------------------------------------------------------------------------
// Import locale json ----------------------------------------------------------
import { keyValidate } from '@helpers/validation';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------

class KoInfoConsent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      threshold: 100,// This calculates as an offset in PX for the header of our site
     

      table: [
        { col: 'info_table_row1', value: ['info_table_value1'] },
        {
          col: 'info_table_row2',
          value: [
            'info_table_value2-1',
            'info_table_value2-2',
            'info_table_value2-3',
            'info_table_value2-4',
            'info_table_value2-5',
          ],
        },
        { col: 'info_table_row3', value: ['info_table_value3'] },
      ],

    };
  }

  componentDidMount() {
    if (window.location.hash === '#info_consent') {
      window.scrollTo(
        0,
        document.getElementById('info_consent_1').offsetTop -
          this.state.threshold
      );
    }
  }

  render() {
    const { t } = this.props;
    return (
      <div id="info_consent_1">
        <p className={styles.leftAlign}>{t('info_header')}</p>
        <p className={styles.marginTop}>{t('info_IntroText')}</p>
        
        <div
          className={styles.tableContainer}
          role="table"
          aria-label="Destinations"
        >
          {this.state.table.map((value, key) => {
            return (
              <div className={styles.rowFlex} role="rowgroup" key={key + value}>
                <div className={styles.first} role="cell">
                  {keyValidate(value.col) && t(value.col)}
                </div>
                <div className={styles.second} role="cell">
                  {value.value.map((key) => {
                    return <li key={key}>{keyValidate(key) && t(key)}</li>;
                  })}
                </div>
              </div>
            );
          })}
        </div>
        
        <p className={styles.marginTop}>{t('info_ending')}</p>
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(KoInfoConsent);
